import { useCallback, useEffect, useState } from 'react';
import { fetchMyCollaborations, fetchMyPortfolio, fetchMySocials } from './api';
import { profileSections } from './profileReadiness';

export function useProfileCompletion(creator) {
  const [collections, setCollections] = useState({ socials: [], portfolio: [], collaborations: [] });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    Promise.all([fetchMySocials(), fetchMyPortfolio(), fetchMyCollaborations()])
      .then(([socials, portfolio, collaborations]) => setCollections({ socials, portfolio, collaborations }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refresh();
    window.addEventListener('profile-section-updated', refresh);
    return () => window.removeEventListener('profile-section-updated', refresh);
  }, [refresh]);

  return { sections: profileSections(creator, collections), collections, loading };
}
